import styles from "./vehicle-list.module.css";
import VehicleFilter from "../Filter";
import List from "./component/List";
import Graph from "./component/Graph";
import { useState } from "react";
import { Clock } from "react-feather";

const VehicleListView = ({
  isGridView,
  handleView,
  filterData,
  setFilterData,
  setAddModalOpen,
  query,
  refreshKey,
  onListChange,
  actions,
  setTenantModalOpen,
  setTenantDetails
}) => {
  const [pendingCount, setPendingCount] = useState(0);
  const showPendingBanner = pendingCount > 0 && filterData?.status !== "pending";

  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            <VehicleFilter
              isGridView={isGridView}
              handleView={handleView.bind(this)}
              filterData={filterData}
              setFilterData={setFilterData.bind(this)}
              setAddModalOpen={setAddModalOpen.bind(this)}
            />

            <div className={`${styles.IncomeListingBody}`}>
              <div className={`${styles.IncomeListSec}`}>
                {showPendingBanner && (<div className={`${styles.PendingBanner}`}>
                  <span className={`${styles.PendingBannerIcon}`}><Clock size={18} /></span>
                  <div className={`${styles.PendingBannerText}`}>
                    <strong>{pendingCount} vehicle{pendingCount === 1 ? " is" : "s are"} waiting for approval.</strong>
                    <span>They have no parking or gate access until a manager approves them.</span>
                  </div>
                  <button type="button" className={`${styles.PendingBannerBu}`} onClick={() => setFilterData((prev) => ({ ...prev, status: "pending" }))}>
                    Review pending
                  </button>
                </div>)}
                <List
                  actions={actions}
                  onMeta={(meta) => setPendingCount(Number(meta?.pending_count) || 0)}
                  isActive={!isGridView}
                  query={query}
                  refreshKey={refreshKey}
                  onListChange={onListChange}
                  setTenantModalOpen={setTenantModalOpen.bind(this)}
                  setTenantDetails={setTenantDetails.bind(this)}
                />
              </div>
              <div className={`${styles.IncomeGraphSec}`}>
                <Graph
                  isActive={!isGridView}
                  query={query}
                  refreshKey={refreshKey}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleListView;
